var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingGarage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09524 7.2381H1.14286C0.510476 7.2381 0 6.72648 0 6.09524V1.90476C0 0.852952 0.853333 0 1.90476 0H6.09524C6.72762 0 7.2381 0.511619 7.2381 1.14286V6.09524C7.2381 6.72648 6.72762 7.2381 6.09524 7.2381Z",
    fill: "#AFC0D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8571 7.2381H9.90476C9.27238 7.2381 8.7619 6.72648 8.7619 6.09524V1.14286C8.7619 0.511619 9.27238 0 9.90476 0H14.0952C15.1467 0 16 0.852952 16 1.90476V6.09524C16 6.72648 15.4895 7.2381 14.8571 7.2381Z",
    fill: "#AFC0D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09524 16H1.90476C0.853333 16 0 15.147 0 14.0952V9.90476C0 9.27352 0.510476 8.7619 1.14286 8.7619H6.09524C6.72762 8.7619 7.2381 9.27352 7.2381 9.90476V14.8571C7.2381 15.4884 6.72762 16 6.09524 16Z",
    fill: "#AFC0D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0952 16H9.90476C9.27238 16 8.7619 15.4884 8.7619 14.8571V9.90476C8.7619 9.27352 9.27238 8.7619 9.90476 8.7619H14.8571C15.4895 8.7619 16 9.27352 16 9.90476V14.0952C16 15.147 15.1467 16 14.0952 16Z",
    fill: "#AFC0D1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingGarage);
export default __webpack_public_path__ + "static/media/landingGarage.08636b3442c562cd875b8cc6a5be193d.svg";
export { ForwardRef as ReactComponent };